/**
* 基础菜单 售后单管理
*/
<template>
  <div class="contianer">
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-date-picker
          v-model="formDate"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.service_code" placeholder="输入服务单号" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.order_code" placeholder="输入订单编号" clearable></el-input>
      </el-form-item>
      <!--      <el-form-item label="">-->
      <!--        <el-input size="small" v-model="formInline.contact_name" placeholder="输入联系人" clearable></el-input>-->
      <!--      </el-form-item>-->
      <!--      <el-form-item label="">-->
      <!--        <el-input size="small" v-model="formInline.contact_tel" placeholder="输入联系电话" clearable></el-input>-->
      <!--      </el-form-item>-->
      <el-form-item label="">
        <el-input size="small" v-model="formInline.product_code" placeholder="输入商品编码/名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.audit_status" placeholder="请选择审核状态" clearable>
          <el-option label="未审核" value="260"></el-option>
          <el-option label="审核通过" value="261"></el-option>
          <el-option label="审核未通过" value="262"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.process_status" placeholder="请选择售后状态" clearable>
          <el-option label="已取消" value="250"></el-option>
          <el-option label="提交申请" value="251"></el-option>
          <el-option label="收货" value="253"></el-option>
          <el-option label="维修中" value="257"></el-option>
          <el-option label="待出货" value="258"></el-option>
          <el-option label="退款" value="254"></el-option>
          <el-option label="完成" value="255"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.service_type" placeholder="请选择服务类型" clearable>
          <el-option v-for="type in CustomerServiceType" :key="type.code" :label="type.name"
                     :value="type.code"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="primary" @click="addSortDialog" v-if="agent_type=='2891'">新增售后单</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 510px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick"
                element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="制单时间" width="135">
          <template slot-scope="scope">
            <div>{{scope.row.create_time}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="service_code" label="服务单号" width="150">
          <template slot-scope="scope">
            <span style="color: #1989FA;cursor: pointer" @click="gotoAftersaleDetail(scope.row.id)">
              {{scope.row.service_code}}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="product_code" label="商品编码" width="180" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="product_name" label="销售名称" min-width="200" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="order_code" label="订单编号" width="150">
        </el-table-column>
        <el-table-column prop="num" label="售后数量" width="80">
        </el-table-column>
        <el-table-column prop="service_type" label="服务类型" width="80">
          <template slot-scope="scope">
            <div plain style="color: #409EFF" v-if="scope.row.service_type==90">
              {{Formatter(scope.row.service_type,'CustomerServiceType')}}
            </div>
            <div plain style="color: #67C23A" v-if="scope.row.service_type==92">
              {{Formatter(scope.row.service_type,'CustomerServiceType')}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="process_status" label="售后处理状态" width="100">
          <template slot-scope="scope">
            <div>{{Formatter(scope.row.process_status,'ProcessStatus')}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="audit_status" label="审核状态" width="100">
          <template slot-scope="scope">
            <div>{{Formatter(scope.row.audit_status,'AuditStatus')}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="audit_name" label="审核人" width="130">
        </el-table-column>
        <el-table-column align="left" label="操作" min-width="100">
          <template slot-scope="scope">

            <div v-if="scope.row.audit_status==260&&scope.row.process_status==251">
              <el-button size="mini" type="warning" style="width: 80px"
                         @click="Audit(scope.row.id,scope.row.service_type)">审核
              </el-button>
            </div>
            <div v-else>
              <el-button size="mini" type="primary" @click="Receipt(scope.row.id,scope.row.service_type)"
                         v-if="scope.row.process_status==253">确认收货
              </el-button>
              <el-button size="mini" type="success" @click="repairMailing(scope.row.id)"
                         v-if="scope.row.service_type==92&&scope.row.process_status==257">维修寄出
              </el-button>
              <el-button size="mini" type="danger" @click="Refund(scope.row.id,scope.row.manual_pay)"
                         v-if="scope.row.process_status==254&&scope.row.service_type==90">确认退款
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog title="审核" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="AuditVisible"
               width="50%" :before-close="handleClose" center>
      <el-form label-width="120px" :model="auditForm" :rules="auditRules" ref="auditForm">
        <el-form-item label="审核状态" prop="audit_result">
          <el-radio-group v-model="auditForm.audit_result" size="small">
            <el-radio label="261" border>通过</el-radio>
            <el-radio label="262" border>不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="退回仓库" prop="stockAreaId">
          <el-radio-group v-model="auditForm.stockAreaId" size="small">
            <el-radio :label="stack.id" border v-for="(stack,index) in stackList" :key="index">
              {{stack.name}}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核回复" prop="audit_text">
          <el-input type="textarea" v-model="auditForm.audit_text" class="textarea" :rows="4" maxLength="200"></el-input>
        </el-form-item>
<!--        <el-form-item label="是否退回供应商" prop="audit_results" v-if="operationtype">-->
<!--          <el-radio-group v-model="auditForm.audit_results" size="small">-->
<!--            <el-radio label="263" border>留在仓库</el-radio>-->
<!--            <el-radio label="264" border>退回供应商</el-radio>-->
<!--          </el-radio-group>-->
<!--        </el-form-item>-->
      </el-form>
<!--      <div class="minitiele" v-if="operationtype">该商品为代发商品，您需要选择留在仓库货、退回供应商，如果选择退回供应商，系统将自动为您生成您与供应商的供货退货单</div>-->
      <div style="text-align: center">
        <el-button size="small" @click="handleClose">关 闭</el-button>
        <el-button size="small" type="primary" :loading="loading" class="save" :disabled="!isCanSubmit" @click="submitAuditForm('auditForm')">保 存
        </el-button>
      </div>
      <p class="saleTitle">售后单详情</p>
      <div class="mb30" v-if="service_type==90">
        <el-table size="small" :data="detailData" highlight-current-row v-loading="loading" border
                  element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column prop="product_name" label="销售名称" min-width="220">
          </el-table-column>
          <el-table-column prop="product_code" label="商品编码" width="220">
          </el-table-column>
          <el-table-column prop="refund_average_price" label="退货价格" width="120">
            <template slot-scope="scope">
              <div>￥{{scope.row.refund_average_price}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="num" label="申请数量" width="120">
          </el-table-column>
          <el-table-column prop="total_refund_price" label="退款金额" width="120">
            <template slot-scope="scope">
              <div>￥{{scope.row.total_refund_price}}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="mb30" v-if="service_type==92">
        <el-table size="small" :data="detailData" highlight-current-row v-loading="loading" border
                  element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column prop="product_name" label="销售名称" min-width="300">
          </el-table-column>
          <el-table-column prop="product_code" label="商品编码" width="150">
          </el-table-column>
          <el-table-column prop="num" label="申请数量" width="100">
          </el-table-column>
        </el-table>
      </div>
      <div class="billing_information">
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">订单号</p>
            <span class="f14 color333">{{detailInfo.order_code}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">联系人</p>
            <span class="f14 color333">{{detailInfo.contact_name}}</span>
          </div>
        </div>
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">服务单号</p>
            <span class="f14 color333">{{detailInfo.service_code}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">联系电话</p>
            <span class="f14 color333">{{detailInfo.contact_tel}}</span>
          </div>
        </div>
        <div class="flex_box">
          <div>
            <div class="flex_box billing_item">
              <p class="label f14 color666">申请时间</p>
              <span class="f14 color333">{{detailInfo.create_time}}</span>
            </div>
            <div class="flex_box billing_item">
              <p class="label f14 color666">售后类型</p>
              <span class="f14 color333" v-if="detailInfo.service_type==90">退货</span>
              <span class="f14 color333" v-else>维修</span>
            </div>
            <div class="flex_box billing_item">
              <p class="label f14 color666">申请凭证</p>
              <span class="f14 color333" v-if="detailInfo.cert_type==400">发票</span>
              <span class="f14 color333" v-else>检测报告</span>
            </div>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666" style="height: 122px;">问题描述</p>
            <span class="f14 color333">{{detailInfo.descr}}</span>
          </div>
        </div>
      </div>
      <p class="picTitle">图片凭证</p>
      <div class="flex_box">
        <div class="image_box" v-for="(pic,index) in pic_list" :key="index">
          <el-image
            style="width: 120px; height: 90px"
            :src="pic"
            fit="cover"
            :preview-src-list="pic_list">
          </el-image>
        </div>
      </div>
    </el-dialog>
    <!-- 维修界面 -->
    <el-dialog title="维修寄出" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="RepairVisible"
               width="50%" top="10vh" @click="closeRepairDialog" center>
      <p class="title f20 color333 fontWeight mb20">发货信息</p>
      <div class="flex_box f15 shipping_information">
        <span class="color333 title mr12">收货人信息</span>
        <div class="flex_box" style="width: calc(100% - 120px)">
          <p class="color666 mr12">
            {{RepairDetailData.contact_name}}，{{RepairDetailData.contact_tel}}，{{RepairDetailData.detail_addr}}</p>
          <span class="copy"
                @click="copy(RepairDetailData.contact_name,RepairDetailData.contact_tel,RepairDetailData.detail_addr)"><img
            src="/static/img/copy.png" alt=""></span>
        </div>
      </div>
      <!--列表-->
      <div class="table mt50" style="">
        <p class="title f20 color333 fontWeight mb20">待寄出商品清单</p>
        <el-table size="small" :data="RepairTable" highlight-current-row v-loading="loading" border
                  element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column prop="product_code" label="商品编码" width="150">
          </el-table-column>
          <el-table-column sortable prop="product_name" label="销售名称" min-width="300">
          </el-table-column>
          <el-table-column sortable prop="num" label="申请数量" width="150">
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
      </div>
      <p class="title f20 color333 fontWeight mb20 mt50">填写物流信息</p>
      <el-form label-width="120px" :model="repairForm" :rules="deliveryrules" ref="repairForm" class="delivery">
        <el-form-item label="快递公司" prop="receiver_delivery_company_id">
          <el-select v-model="repairForm.receiver_delivery_company_id" filterable placeholder="请选择快递公司" clearable>
            <el-option
              v-for="item in popularDeliveryListData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="快递单号" prop="receiver_delivery_no">
          <el-input size="small" v-model="repairForm.receiver_delivery_no" auto-complete="off" placeholder="请输入快递单号" clearable
                    maxLength="50"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="RepairVisible=false">关 闭</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" :disabled="!isCanSubmit"
                   @click="submitDeliveryForm('repairForm')">确认发货
        </el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="退款"
               :visible.sync="editPaidDialogVisible"
               width="30%"
               center>
      <el-form label-width="120px" :model="editPaidForm" ref="editPaidForm" class="editPaidForm">
        <el-form-item label="退款凭证" prop="list_pic_url" class="list_pic_url">
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            :on-remove="handleRemove"
            :http-request="handleUpload"
            :before-upload="beforeUpload"
          >
            <img v-if="form.image" :src="form.image" class="avatar"/>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <div style="text-align: center;color: #A8ABB2">单张图片大小不得超过1M，仅支持jpg、jpeg、png格式</div>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="editPaidDialogVisible = false">关 闭</el-button>
            <el-button type="primary" @click="sureEditPaid('editPaidForm')" :disabled="!isCanSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    aftersaleList,
    checkDetail,
    serviceCheck,
    confirmReceipt,
    confirmRefund,
    repairDetail,
    repairDelivery,
    popularDeliveryList, confirmPayed
  } from '../../api/basisMG'
  import {param, upload, uploadImgTmp,getToken} from '../../api/commonMG'
  import Pagination from '../../components/Pagination'
  import {timestampToDate,uploadFile} from "../../utils/util";

  export default {
    data: () => {
      return {
        id: '',
        dateTime: '',
        loading: false, //是显示加载
        AuditVisible: false, //控制编辑页面显示与隐藏
        RepairVisible: false,
        stackList: [],
        detailInfo: {},
        pic_list: [],
        RepairTable: [],
        RepairDetailData: {},
        title: '添加',
        auditForm: {
          id: '',
          audit_result: '261',
          stockAreaId: '',
          audit_text: '',
          audit_results: '263',
        },
        auditRules: {
          audit_result: [
            {required: true, message: '请选择审核状态', trigger: 'change'}
          ],
          stockAreaId: [{required: true, message: '请选择退回仓库', trigger: 'change'}],
          audit_text: [{required: true, message: '请输入审核回复', trigger: 'blur'}],
          audit_results: [{required: true, message: '请选择是否退回供应商', trigger: 'blur'}],
        },
        deliveryrules: {
          receiver_delivery_no: [{required: true, message: '请填写快递单号', trigger: 'blur'}],
          receiver_delivery_company_id: [{required: true, message: '请选择物流公司', trigger: 'change'}],
        },
        repairForm: {
          receiver_delivery_company_id: '',
          receiver_delivery_no: '',
        },
        formDate: '',
        formInline: {
          page: 1,
          rows: 10,
          service_type: '',
          service_code: '',
          order_code: '',
          product_code: '',
          contact_name: '',
          contact_tel: '',
          process_status: '',
          audit_status: '',
          begin_time: '',
          end_time: '',
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        CustomerServiceType: [],
        AuditStatus: [],
        ProcessStatus: [],
        CancelType: [],
        detailData: [],
        popularDeliveryListData: [],
        value: '',
        service_type: '',
        isCanSubmit: true,
        editPaidDialogVisible: false,
        imgUrl:'',
        custInvoiceId:'',
        editPaidForm:{},
        form: {
          image: ''
        },
        agent_type: localStorage.getItem('agent_type')||'2891',
        operationtype: false,
        operation_type: ''
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      if (this.$route.query.audit_status) {
        this.formInline.audit_status = this.$route.query.audit_status
        this.getdata(this.formInline)
      } else {
        this.getdata(this.formInline)
      }
    },
    mounted() {
      this.getParam('CustomerServiceType')
      this.getParam('AuditStatus')
      this.getParam('ProcessStatus')
      this.getParam('CancelType')
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },
      //过滤
      Formatter(value, type) {
        if (type == 'CustomerServiceType') {
          for (let item of this.CustomerServiceType) {
            if (item.code == value) {
              return item.name
            }
          }
        } else if (type == 'AuditStatus') {
          for (let item of this.AuditStatus) {
            if (item.code == value) {
              return item.name
            }
          }
        } else if (type == 'ProcessStatus') {
          for (let item of this.ProcessStatus) {
            if (item.code == value) {
              return item.name
            }
          }
        } else if (type == 'CancelType') {
          for (let item of this.CancelType) {
            if (item.code == value) {
              return item.name
            }
          }
        }
      },
      //获取系统字典
      getParam(type) {
        param(type)
          .then(res => {
            if (res.success) {
              if (type == 'CustomerServiceType') {
                this.CustomerServiceType = res.content;
              } else if (type == 'AuditStatus') {
                this.AuditStatus = res.content;
              } else if (type == 'ProcessStatus') {
                this.ProcessStatus = res.content;
              } else if (type == 'CancelType') {
                this.CancelType = res.content;
              }
            }
          })
          .catch(err => {
          })
      },
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        aftersaleList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows;
              this.operation_type = res.content.rows.operation_type;
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('菜单加载失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        console.log(parm)
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        if (this.formDate) {
          this.formInline.begin_time = timestampToDate(this.formDate[0])
          this.formInline.end_time = timestampToDate(this.formDate[1])
        } else {
          this.formInline.begin_time = ''
          this.formInline.end_time = ''
        }
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
      searchSelect() {
        if (this.order_complete_time) {
          this.formInline.start_discuss_time = timestampToDate(this.order_complete_time[0])
          this.formInline.end_discuss_time = timestampToDate(this.order_complete_time[1])
        } else {
          this.formInline.start_discuss_time = ''
          this.formInline.end_discuss_time = ''
        }
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
      // 关闭编辑、增加弹出框
      handleClose() {
        this.$refs["auditForm"].resetFields();
        this.AuditVisible = false
      },
      closeRepairDialog() {
        this.RepairVisible = false
      },
      //跳转服务单详情
      gotoAftersaleDetail(id) {
        localStorage.setItem('path', '/aftersale/aftersaleDetail')
        let tag = {
          url: "/aftersale/aftersaleDetail",
          menuname: "服务单详情"
        }
        this.$store.commit('selectMenu', tag)
        this.$router.push({path: '/aftersale/aftersaleDetail', query: {id: id}})
      },
      Audit(id, service_type) {
        this.auditForm.id = id;
        this.AuditVisible = true;
        this.service_type = service_type;
        if (this.operation_type == 2910) {
          this.operationtype = false
        } else {
          this.operationtype = true
        }
        this.detailData = [];
        checkDetail(id)
          .then(res => {
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.stackList = res.content.stock_area_list;
              this.auditForm.stockAreaId = res.content.stock_area_list[0].id;
              this.pic_list = res.content.pic_list;
              if (res.content.detail_info) {
                this.detailInfo = res.content.detail_info;
                this.detailInfo.service_type = service_type;
                this.detailData.push(res.content.detail_info)
              }
            }
          })
          .catch(err => {
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 点击复制
      copy(name, phone, addr) {
        let url = name + ',' + phone + ',' + addr;
        let oInput = document.createElement('input');
        oInput.value = url;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message({
          message: '复制成功',
          type: 'success'
        });
        oInput.remove()
      },
      submitAuditForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            this.isCanSubmit = false;
            serviceCheck(this.auditForm)
              .then(res => {
                this.isCanSubmit = true;
                this.loading = false;
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '审核成功'
                  })
                  this.handleClose()
                  this.getdata(this.formInline)
                }
              })
              .catch(err => {
                this.isCanSubmit = true;
                this.loading = false;
                this.$message.error('网络错误，请稍后再试！')
              })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      //确认收货
      Receipt(id, service_type) {
        if (service_type == 90) {
          var title = '确认已收到退货商品，并将售后状态改为待退款？'
        } else {
          var title = '确认已收到维修商品，并将售后状态改为维修中？'
        }
        this.$confirm(title, '确认收货', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          confirmReceipt(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '收货成功!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      //确认退款
      Refund(id,manual_pay) {
        this.id = id;
        if(!manual_pay){
          this.$confirm('确认退款并将售后状态改为已完成吗？', '确认退款', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loading = true
            confirmRefund(id,'')
              .then(res => {
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '申请成功,等待财务退款！'
                  });
                  this.getdata(this.formInline)
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        } else {
          this.editPaidDialogVisible = true;
          this.form.image = '';
          this.imgUrl = '';
        }
      },
      //维修寄回
      repairMailing(id) {
        this.id = id;
        this.RepairVisible = true;
        this.loading = true;
        this.repairForm = {};
        this.RepairTable = [];
        repairDetail(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.RepairDetailData = res.content;
              this.RepairTable.push(res.content)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
        let data = {
          "page": 1,
          "rows": 10,
          "name": ""
        }
        popularDeliveryList(data)
          .then(res => {
            if (res.success) {
              this.popularDeliveryListData = res.content;
            }
          })
          .catch(err => {
            this.$message.error('网络错误，请稍后再试！')
          })
        // deliveryList(data)
        //   .then(res => {
        //     if (res.success) {
        //
        //     }
        //   })
        //   .catch(err => {
        //     this.$message.error('网络错误，请稍后再试！')
        //   })
      },
      //确认收货
      submitDeliveryForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.repairForm.service_id = this.id;
            this.isCanSubmit = false;
            this.loading = true;
            repairDelivery(this.repairForm)
              .then(res => {
                this.isCanSubmit = true;
                this.loading = false;
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '发货成功!'
                  });
                  this.getdata(this.formInline)
                  this.RepairVisible = false;
                }
              })
              .catch(err => {
                this.isCanSubmit = true;
                this.loading = false;
                this.$message.error('网络错误，请稍后再试！')
              })
          } else {
            console.log('error submit!!');
          }
        });
      },
      handleRemove(file) {
        console.log(file);
      },
      // 可以获取图片参数
      handleUpload(file) {
        console.log(file)
      },
      beforeUpload(file) {
        const isJPG = file.type === "image/jpeg" || file.type == "image/png" || file.type == "image/jpg";
        const isLt1M = file.size / 1024 / 1024 < 1;
        if (!isJPG) {
          this.$message.warning("上传图片仅支持jpg、jpeg、png格式!");
          return false
        }
        if (!isLt1M) {
          this.$message.warning("上传图片大小不能超过 1MB!");
          return false
        }
        const fileData = new FormData();
        fileData.append("file", file);
        //upload为上传的接口
        getToken().then(res => {
          if(res) {
            let result = uploadFile(res,file);
            result.then(res => {
              this.imgUrl =  res.data.content.file.fileUrl;
              //对返回的图片地址进行回显
              this.$set(this.form, "image",  res.data.content.file.fileUrl);
            })
          }
        });
        // 调用[限制图片尺寸]函数
        // this.limitFileWH(240, 240, file)
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.product_name == cell.innerText || row.product_code == cell.innerText || row.service_code == cell.innerText || row.order_code == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      },
      sureEditPaid() {
        if (this.imgUrl == '') {
          this.$message.error('支付凭证图片不能为空!');
          return
        }
        this.loading = true;
        confirmRefund(this.id,this.imgUrl)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '申请成功,等待财务退款！'
              });
              this.editPaidDialogVisible = false;
              this.getdata(this.formInline)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 新增售后单
      addSortDialog() {
        localStorage.setItem('path', '/aftersale/addAftersale')
        let tag = {
          url: "/aftersale/addAftersale",
          menuname: "新增售后单"
        }
        this.$store.commit('selectMenu', tag)
        this.$router.push('/aftersale/addAftersale')
      },
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  .mr12 {
    margin-right: 12px;
  }

  .mt50 {
    margin-top: 50px;
  }

  .mb10 {
    margin-bottom: 10px;
  }

  .mb20 {
    margin-bottom: 20px;
  }

  .f15 {
    font-size: 15px;
  }

  .f14 {
    font-size: 14px;
  }

  .f20 {
    font-size: 20px;
  }

  .fontWeight {
    font-weight: 600;
  }

  .color333 {
    color: #333333;
  }

  .color666 {
    color: #666666;
  }

  .flex_box {
    display: flex;
  }

  .mb30 {
    margin-bottom: 30px;
  }

  .userRole {
    width: 100%;
  }

  .image_box {
    margin-right: 30px;
  }

  .flex_box {
    display: flex;
  }

  .label {
    width: 120px;
    height: 40px;
    line-height: 40px;
    background: #F5F7FA;
    padding-left: 12px;
  }

  .billing_item {
    border-bottom: 1px solid #EBEEF5;
  }

  .billing_item span {
    height: 40px;
    padding-left: 12px;
    padding-right: 15px;
    width: 300px;
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
  }

  .copy {
    width: 20px;
    height: 20px;
  }

  .copy img {
    width: 20px;
    height: 20px;
  }

  /deep/ .textarea textarea {
    resize: none;
    width: 300px;
  }

  /deep/ .delivery .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 217px;
  }
  /deep/ .delivery .el-input--small {
    height: 40px;
    line-height: 40px;
    width: 217px;
  }

  .saleTitle {
    color: #333333;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 12px;
    margin-top: 25px;
  }

  .picTitle {
    color: #333333;
    font-size: 15px;
    font-weight: 400;
    margin: 20px 0;
  }

  /deep/ .delivery .el-form-item {
    margin-left: 25%;
  }
  .breadcrumb {
    margin-bottom: 15px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border: 1px dashed #DCDFE6;
  }

  .avatar {
    width: 120px;
    height: 120px;
    display: block;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .avatar-uploader {
    height: 122px;
  }

  /deep/ .list_pic_url label:before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }

  .minitiele {
    font-size: 12px;
    color: #D9001B;
    margin-bottom: 20px;
  }
</style>





// WEBPACK FOOTER //
// src/views/aftersale/Aftersale.vue